module.exports = __webpack_public_path__ + "images/turtle-901b63.svg";